import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ledger-account-grid',
  templateUrl: './ledger-account-grid.component.html',
  styleUrls: ['./ledger-account-grid.component.css']
})
export class LedgerAccountGridComponent implements OnInit {
title="Ledger Account List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/ledger-account-grid/ledger-account-grid.component.ts